import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { differenceInSeconds } from 'date-fns';
import { useFetchUserMeetingAnalysis } from 'actions/users';
import useSearchParameter from 'hooks/useSearchParameter';
import { getHelixUIMode } from 'utils/helix';
import config from 'utils/config';
import { openMindsetCoachingPanel } from 'utils/mindset';
import Heading from 'components/Heading';
import EmptyStateController from 'components/EmptyStateController';
import Stack from 'components/Stack';
import InlineList from 'components/InlineList';
import FriendlyDuration from 'components/FriendlyDuration';
import Box from 'components/Box';
import Flex from 'components/Flex';
import BarChartCard from 'components/BarChartCard';
import VisuallyHidden from 'components/VisuallyHidden';
import SkillScoreFlagCard from '../components/SkillScoreFlagCard';
import SummaryFlagCard from '../components/SummaryFlagCard';
import SkillPageWrapper from '../components/SkillPageWrapper';
import NoTrackedMeetingsEmptyContent from '../components/NoTrackedMeetingsEmptyContent';
import HelixInfoButton from '../components/HelixInfoButton';
import Feedback from '../components/Feedback';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function MeetingAnalysisPage(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    user = _ref.user,
    getUserSkillLocation = _ref.getUserSkillLocation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var _useParams = useParams(),
    meetingId = _useParams.meetingId;
  var _useSearchParameter = useSearchParameter('skillId'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    skillIdToScrollTo = _useSearchParameter2[0];
  var _useSearchParameter3 = useSearchParameter('q'),
    _useSearchParameter4 = _slicedToArray(_useSearchParameter3, 1),
    coachQ = _useSearchParameter4[0];
  var _useSearchParameter5 = useSearchParameter('skillName'),
    _useSearchParameter6 = _slicedToArray(_useSearchParameter5, 1),
    coachSkillName = _useSearchParameter6[0];
  var _useSearchParameter7 = useSearchParameter('coachingContext'),
    _useSearchParameter8 = _slicedToArray(_useSearchParameter7, 1),
    coachingContext = _useSearchParameter8[0];
  useEffect(function () {
    if (!coachQ) return;
    if (config.isTrialHub) {
      openMindsetCoachingPanel({
        skillName: coachSkillName ? String(coachSkillName) : undefined,
        coachingContext: coachingContext ? String(coachingContext) : ''
      });
    } else {
      navigate("/coach-ai?q=".concat(encodeURIComponent(coachQ), "&skillName=").concat(encodeURIComponent(coachSkillName || ''), "&coachingContext=").concat(encodeURIComponent(coachingContext || '')), {
        replace: true
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var _getHelixUIMode = getHelixUIMode(),
    showScores = _getHelixUIMode.showScores,
    showFeedback = _getHelixUIMode.showFeedback;
  var cardRefs = useRef({});
  var _useFetchUserMeetingA = useFetchUserMeetingAnalysis({
      userId: userId,
      meetingId: meetingId
    }),
    meeting = _useFetchUserMeetingA.data,
    isLoading = _useFetchUserMeetingA.isLoading,
    isError = _useFetchUserMeetingA.isError;
  var meetingSkillsTitleId = 'skills-this-meeting-heading';
  var startTime = meeting !== null && meeting !== void 0 && meeting.startTime ? new Date(meeting.startTime) : undefined;
  var formattedDate = startTime ? startTime.toLocaleDateString('en-GB', {
    dateStyle: 'medium'
  }) : undefined;
  var formattedTime = startTime ? startTime.toLocaleTimeString('en-GB', {
    timeStyle: 'short',
    hour12: true
  }) : undefined;
  var duration = meeting !== null && meeting !== void 0 && meeting.endTime && meeting !== null && meeting !== void 0 && meeting.startTime ? differenceInSeconds(new Date(meeting.endTime), new Date(meeting.startTime)) : undefined;
  var userMeetingSkills = useMemo(function () {
    return (meeting === null || meeting === void 0 ? void 0 : meeting.userMeetingSkills) || [];
  }, [meeting === null || meeting === void 0 ? void 0 : meeting.userMeetingSkills]);
  var hasSkills = userMeetingSkills.length > 0;
  var barChartData = useMemo(function () {
    return (userMeetingSkills === null || userMeetingSkills === void 0 ? void 0 : userMeetingSkills.map(function (skill) {
      return skill.score;
    })) || [];
  }, [userMeetingSkills]);
  var barChartLabels = useMemo(function () {
    return (userMeetingSkills === null || userMeetingSkills === void 0 ? void 0 : userMeetingSkills.map(function (skill) {
      return skill.name;
    })) || [];
  }, [userMeetingSkills]);
  var skillsRecorded = useMemo(function () {
    var _userMeetingSkills$fi;
    return userMeetingSkills === null || userMeetingSkills === void 0 || (_userMeetingSkills$fi = userMeetingSkills.filter(function (skill) {
      return skill.id;
    }) // Has an analysis record associated
    ) === null || _userMeetingSkills$fi === void 0 ? void 0 : _userMeetingSkills$fi.sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
  }, [userMeetingSkills]);
  var skillsNotRecorded = useMemo(function () {
    var _userMeetingSkills$fi2;
    return userMeetingSkills === null || userMeetingSkills === void 0 || (_userMeetingSkills$fi2 = userMeetingSkills.filter(function (skill) {
      return !skill.id;
    }) // Has no analysis record associated
    ) === null || _userMeetingSkills$fi2 === void 0 ? void 0 : _userMeetingSkills$fi2.sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
  }, [userMeetingSkills]);

  // Scroll the selected skill into view if skillId is in search params
  useLayoutEffect(function () {
    if (!skillIdToScrollTo) return;
    var target = cardRefs.current[skillIdToScrollTo];
    if (target) {
      var offset = 100; // Prevent header from overlapping
      var targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  }, [skillIdToScrollTo, skillsRecorded]);
  if (!meetingId) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkillPageWrapper, {
    fallbackLink: getUserSkillLocation({}),
    user: user,
    children: /*#__PURE__*/_jsxs(EmptyStateController, {
      isLoading: isLoading,
      isError: isError,
      isEmpty: !meeting,
      emptyContent: /*#__PURE__*/_jsx(NoTrackedMeetingsEmptyContent, {
        isCurrentUser: isCurrentUser
      }),
      children: [/*#__PURE__*/_jsxs(Flex, {
        gap: "xxs",
        breakpoints: "xs",
        flexDirection: ['column-reverse', 'row'],
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Box, {
          flexAlign: "left",
          children: /*#__PURE__*/_jsx(Heading, {
            as: "h2",
            children: meeting === null || meeting === void 0 ? void 0 : meeting.title
          })
        }), /*#__PURE__*/_jsx(Box, {
          flexAlign: "right",
          children: /*#__PURE__*/_jsx(HelixInfoButton, {})
        })]
      }), /*#__PURE__*/_jsx(Box, {
        fontSize: "s",
        mt: "xxs",
        mb: "m",
        children: /*#__PURE__*/_jsxs(InlineList, {
          splitBy: "dot",
          as: "p",
          itemAs: "span",
          display: "inline",
          dimmed: true,
          children: [formattedDate, formattedTime, duration && /*#__PURE__*/_jsx(FriendlyDuration, {
            value: duration
          }), /*#__PURE__*/_jsx(_Fragment, {
            children: t('skills_organised_by', {
              user: meeting === null || meeting === void 0 ? void 0 : meeting.organiserEmail
            })
          }), meeting === null || meeting === void 0 ? void 0 : meeting.meetingPlatform]
        })
      }), /*#__PURE__*/_jsx(VisuallyHidden, {
        as: "h3",
        id: meetingSkillsTitleId,
        children: t('skills_title_skills_this_meeting')
      }), showScores && hasSkills && /*#__PURE__*/_jsx(Box, {
        mb: "l",
        children: /*#__PURE__*/_jsx(BarChartCard, {
          titleId: meetingSkillsTitleId,
          ariaLabel: t('skills_this_meeting_aria_label'),
          nullLabel: t('skills_no_score'),
          data: barChartData,
          labels: barChartLabels,
          onXLabelClick: function onXLabelClick(label) {
            var skill = userMeetingSkills === null || userMeetingSkills === void 0 ? void 0 : userMeetingSkills.find(function (skill) {
              return skill.name === label;
            });
            if (skill) {
              var skillId = skill.skillId;
              navigate(getUserSkillLocation({
                skillId: skillId
              }));
            }
          }
        })
      }), showFeedback && (meeting === null || meeting === void 0 ? void 0 : meeting.summary) && /*#__PURE__*/_jsx(Box, {
        mb: "l",
        maxWidth: 860,
        children: /*#__PURE__*/_jsx(SummaryFlagCard, {
          summary: meeting.summary,
          screenContext: _objectSpread({
            description: 'AI-generated summary of this meeting',
            id: meetingId
          }, userId && {
            state: {
              userId: userId
            }
          })
        })
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "l",
        maxWidth: 860,
        as: "list",
        children: [skillsRecorded === null || skillsRecorded === void 0 ? void 0 : skillsRecorded.map(function (skill) {
          var skillId = String(skill.skillId);
          return /*#__PURE__*/_jsxs("div", {
            ref: function ref(el) {
              if (el) cardRefs.current[skillId] = el;
            },
            children: [/*#__PURE__*/_jsx(SkillScoreFlagCard, {
              isCurrentUser: isCurrentUser,
              skill: skill,
              getLink: getUserSkillLocation
            }), isCurrentUser && skill.id && /*#__PURE__*/_jsx(Feedback, {
              meetingId: meetingId,
              userId: userId,
              userMeetingSkillId: skill.id,
              feedback: skill.feedback,
              skillName: skill.name
            })]
          }, "meeting-skill-recorded-".concat(skillId));
        }), skillsNotRecorded === null || skillsNotRecorded === void 0 ? void 0 : skillsNotRecorded.map(function (skill) {
          return /*#__PURE__*/_jsx(SkillScoreFlagCard, {
            isCurrentUser: isCurrentUser,
            skill: skill,
            userId: userId,
            getLink: getUserSkillLocation
          }, "meeting-skill-not-recorded".concat(skill === null || skill === void 0 ? void 0 : skill.skillId));
        })]
      })]
    })
  });
}
export default MeetingAnalysisPage;